export const constructFromAndToDates = (mostRecentTenureMonths: number) => {
  const dateInThePast = new Date();
  dateInThePast.setMonth(dateInThePast.getMonth() - mostRecentTenureMonths);
  const now = new Date();
  return {
    from: {
      month: dateInThePast.getMonth() + 1,
      year: dateInThePast.getFullYear(),
    },
    to: {
      month: now.getMonth() + 1,
      year: now.getFullYear(),
    },
  };
};
